import React from "react";
import Select from "react-select";

const timeframe2Options = [
	{label: "1 minute", value: "1m"},
	{label: "3 minutes", value: "3m"},
	{label: "5 minutes", value: "5m"},
	{label: "10 minutes", value: "10m"},
	{label: "15 minutes", value: "15m"},
	{label: "30 minutes", value: "30m"},
	{label: "45 minutes", value: "45m"},
	{label: "60 minutes", value: "60m"},
	{label: "6 hours", value: "360m"},
	{label: "12 hours", value: "720m"},
	{label: "24 hours", value: "1440m"},
	{label: "Today so far", value: "midnight"},
];

const timeFrameFrom5Min = [
	{label: "5 minutes", value: "5m"},
	{label: "10 minutes", value: "10m"},
	{label: "15 minutes", value: "15m"},
	{label: "30 minutes", value: "30m"},
	{label: "45 minutes", value: "45m"},
	{label: "60 minutes", value: "60m"},
	{label: "6 hours", value: "360m"},
	{label: "12 hours", value: "720m"},
	{label: "24 hours", value: "1440m"},
	{label: "Today so far", value: "midnight"},
];

const timeFrame30min = [
	{label: "1 minute", value: "1m"},
	{label: "3 minutes", value: "3m"},
	{label: "5 minutes", value: "5m"},
	{label: "10 minutes", value: "10m"},
	{label: "15 minutes", value: "15m"},
	{label: "30 minutes", value: "30m"},
	{label: "Today so far", value: "midnight"},
];

const timeFrame12Hours = [
	{ label: "30 minutes", value: "30m" },
	{ label: "1 hour", value: "60m" },
	{ label: "6 hours", value: "360m" },
	{ label: "12 hours", value: "720m" },
	{ label: "24 hours", value: "1440m" },
	{ label: "Today so far", value: "midnight" },
];

type Props = {
	isDisabled?: boolean,
	updateConfig: Function,
	timeWindow: string,
	timeFrameType?: string
}

type Option = {
	value: string,
	label: string
}

const TimeWindow = (props: Props) => {
	let timeFrameOptions;

	switch (props.timeFrameType) {
		case 'default':
			timeFrameOptions = timeframe2Options;
			break;
		case 'from5min':
			timeFrameOptions = timeFrameFrom5Min;
			break;
		case '30min':
			timeFrameOptions = timeFrame30min;
			break;
		case '12hours':
			timeFrameOptions = timeFrame12Hours;
			break;
		default:
			timeFrameOptions = timeframe2Options;
			break;
	}

	const getSelectedOption = (key: string, items: Array<Option>) => {
		if (!key) {
			return items.find(item => item.value === "30m");
		}

		const result = items.find(item => item.value === key);

		if (!result) {
			setTimeout(() => {
				props.updateConfig(['time_window'], ["30m"]);
			}, 1);
			return items.find(item => item.value === "30m");
		}

		return result;
	};

	return (
		<div className="form-group">
			<label htmlFor="timeFrameCompared">Time window</label>
			<Select
				id="timeFrameTime"
				className="basic-single"
				classNamePrefix="so-select-sort"
				isSearchable={true}
				isDisabled={props.isDisabled}
				value={getSelectedOption(props.timeWindow, timeFrameOptions)}
				options={timeFrameOptions}
				onChange={e => props.updateConfig(['time_window'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

TimeWindow.defaultProps = {
	timeFrameType: 'default'
};

export default TimeWindow;
